<template>
  <InShareUsersTable />
</template>

<script lang="ts" setup>
import InShareUsersTable from '@/components/deepbox/in-share/InShareUsersTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.in_share.users',
  },
})
</script>
